module.exports = __webpack_public_path__ + "Roboto-BoldItalic.a7dce23c0dd99a4afa5c.woff";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-BoldItalic.woff
// module id = 135
// module chunks = 10